import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

// Live CONFIG

const config = {
  apiKey: "AIzaSyADGg5ErMjFicdFNsSHADbcooNTDnCoBkQ",
  authDomain: "myrights-91d89.firebaseapp.com",
  databaseURL: "https://myrights-91d89-default-rtdb.firebaseio.com",
  projectId: "myrights-91d89",
  storageBucket: "myrights-91d89.appspot.com",
  messagingSenderId: "470998251074",
  appId: "1:470998251074:web:a0ce71da14020612f45fdb",
  measurementId: "G-Q1E1475PKE"
};


// UAT CONFIG

// const config = {
//   apiKey: "AIzaSyDRLJtbIfr3ojBpDKADsPKdewL0VRTP-MY",
//   authDomain: "imonitornextgen-uat.firebaseapp.com",
//   databaseURL: "https://imonitornextgen-uat-default-rtdb.firebaseio.com",
//   projectId: "imonitornextgen-uat",
//   storageBucket: "imonitornextgen-uat.appspot.com",
//   messagingSenderId: "345094457694",
//   appId: "1:345094457694:web:f4c5cd75c8d52bfd4f27cf",
//   measurementId: "G-ZPG5JNEFD0"
// };

firebase.initializeApp(config);

export const auth = firebase.auth;
export const db = firebase.database();

